import { identifyTransactionEntityIds, makeEntityPair, makeEntityPairId } from '@local_modules/generic/zenflow-financials/intercompany/make-entity-pair'
import dayjs from 'dayjs'

export function identifyIntercoParameters (transactions, dateGroupingMethod) {
  const groupingDateFormat = (dateGroupingMethod === 'byDay') ? 'YYYY-MM-DD' : 'YYYY-MM'

  transactions.forEach(function (transaction) {
    transaction._entitiesPairIds = identifyTransactionEntityIds(transaction)
    transaction._entitiesPair = makeEntityPair(transaction)
    transaction._entitiesPairId = makeEntityPairId(transaction)

    transaction._dateGroup = dayjs(transaction.ledger_date).format(groupingDateFormat)
  })
}
